import { createSlice } from "@reduxjs/toolkit/";

const loadFromSession = () => {
  try {
    const steps = JSON.parse(sessionStorage.getItem("stepper_steps"));
    const raw = sessionStorage.getItem("stepper_currentStep");
    const currentStep = raw !== null ? Number(raw) : "";
    return {
      steps: Array.isArray(steps) ? steps : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      currentStep,
    };
  } catch {
    return { steps: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], currentStep: "" };
  }
};

const initialState = loadFromSession();

export const stepperSlice = createSlice({
  name: "stepper",
  initialState,

  reducers: {
    setsteps: (state, action) => {
      const next = action.payload;
      if (
        state.steps.length === next.length &&
        state.steps.every((v, i) => v === next[i])
      ) return;
      state.steps = next;
      sessionStorage.setItem("stepper_steps", JSON.stringify(next));
    },

    setCurrentStep: (state, action) => {
      if (state.currentStep === action.payload) return;
      state.currentStep = action.payload;
      sessionStorage.setItem("stepper_currentStep", action.payload);
    },
  },
});


export const getsteps = (state) => state.stepper.steps;
export const getCurrentStep = (state) => state.stepper.currentStep;

export const { setsteps, setCurrentStep } = stepperSlice.actions;

export default stepperSlice.reducer;
